import React from "react";
import { Form, Modal, Row } from "react-bootstrap";
import Fontstyling from "../../../../components/common/comman";
import { useState } from "react";
import { useRef } from "react";
import { useEffect } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import {
  GetSalaryRisk,
  AddSalaryRisk,
  UpdateSalaryRisk,
  DeleteSalaryRisk,
} from "../../../../api/User/ACG/SalaryRiskApi";
import CustomButton from "../../../../components/common/CustomButton";
import DeleteModal from "../../../../components/common/Modal/DeleteModal";
import CustomMaterialTable from "../../../../components/common/CustomMaterialTable";
import toastFile from "../../../../Service/ToastFile";
import CustomInputField from "../../../../components/common/CustomInputField";

const schema = Yup.object().shape({
  salary_Range_low: Yup.number()
    .integer("Number must be an integer")
    .typeError("Please enter a valid number")
    .required("Please enter Salary Range (low)"),
  salary_Range_high: Yup.number()
    .integer("Number must be an integer")
    .typeError("Please enter a valid number")
    .required("Please enter Salary Range (high)"),
  salary_Risk_Percentile: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter Salary Risk Percentile"),
});

const SalaryRisk = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [isGetData, setIsGetData] = useState(false);
  const [witchAction, setWitchAction] = useState("");
  const [showModal, setShowModal] = useState(false);
  const buttonRef = useRef(null);
  const [selectedRow, setSelectedRow] = useState(null);

  const column = [
    { title: "Salary Range (low)", field: "salary_Range_low" },
    { title: "Salary Range (high)", field: "salary_Range_high" },
    {
      title: "Salary Risk Percentile",
      field: "salary_Risk_Percentile",
      render: (rowData) =>
        (+rowData.salary_Risk_Percentile * 100).toFixed(2) + "%",
    },
  ];

  useEffect(() => {
    if (showModal === false) {
      setSelectedRowData(null);
    }
    if (isGetData) {
      getSalaryRiskData();
    }
    setIsGetData(false);
  }, [showModal]);

  useEffect(() => {
    getSalaryRiskData();
  }, []);

  const getSalaryRiskData = () => {
    setIsLoading(true);
    GetSalaryRisk()
      .then((res) => {
        if(res.status === 200 || res.status === 204){
        setData(res.data);
        }
      })
      .catch((err) => console.log({ err }))
      .finally((res) => setIsLoading(false));
  };

  const handleActions = (values) => {
    buttonRef.current.disabled = true;

    const { salary_Range_low, salary_Range_high, salary_Risk_Percentile } =
      values;
    const payload = {
      id: 0,
      salary_Range_low: +salary_Range_low,
      salary_Range_high: +salary_Range_high,
      salary_Risk_Percentile: +salary_Risk_Percentile,
    };

    if (witchAction === "add") {
      AddSalaryRisk(payload).then((res) => {
        if(res.status === 200 || res.status === 204){
        setIsGetData(true);
        toastFile("new");
        setShowModal(false);
        }
      });
    } else if (witchAction === "update") {
      UpdateSalaryRisk({ ...payload, id: selectedRowData.id }).then((res) => {
        if(res.status === 200 || res.status === 204){
        setIsGetData(true);
        toastFile("update");
        setShowModal(false);
        }
      });
    }
  };

  return (
    <div>
      <Modal
        show={showModal}
        aria-labelledby="contained-modal-title-vcenter"
        centered={witchAction !== "delete"}
      >
        <Modal.Header closeButton onHide={() => setShowModal(false)}>
          <Modal.Title
            id="contained-modal-title-vcenter"
            style={Fontstyling.modalHeading}
          >
            {witchAction === "add"
              ? "Add "
              : witchAction === "update"
              ? "Update "
              : "Delete "}
            Salary Risk
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {witchAction === "delete" ? (
            <DeleteModal
              onClickYes={() => {
                DeleteSalaryRisk(selectedRowData?.id).then((res) => {
                  if(res.status === 200 || res.status === 204){
                  toastFile("delete");
                  setIsGetData(true);
                  setShowModal(false);
                  }
                });
              }}
              onClickNo={() => setShowModal(false)}
            />
          ) : (
            <Formik
              validationSchema={schema}
              onSubmit={handleActions}
              initialValues={{
                salary_Range_low: selectedRowData?.salary_Range_low ?? 0,
                salary_Range_high: selectedRowData?.salary_Range_high ?? 0,
                salary_Risk_Percentile:
                  selectedRowData?.salary_Risk_Percentile ?? 0,
              }}
            >
              {({
                handleSubmit,
                handleChange,
                handleBlur,
                values,
                touched,
                errors,
              }) => (
                <Form onSubmit={handleSubmit}>
                  <Row className="mb-2 gap-3">
                    <CustomInputField
                      label="Salary Range (low)"
                      name="salary_Range_low"
                      maxLength={10}
                      value={values}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      touched={touched}
                      errors={errors}
                      isRequired
                    />
                    <CustomInputField
                      label="Salary Range (high)"
                      name="salary_Range_high"
                      maxLength={10}
                      value={values}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      touched={touched}
                      errors={errors}
                      isRequired
                    />
                    <CustomInputField
                      label="Salary Risk Percentile"
                      name="salary_Risk_Percentile"
                      maxLength={10}
                      value={values}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      touched={touched}
                      errors={errors}
                      isRequired
                    />
                  </Row>
                  <div className="d-flex align-items-center justify-content-end gap-3 my-4">
                    <button
                      ref={buttonRef}
                      style={Fontstyling.savebutton}
                      type="submit"
                    >
                      save
                    </button>
                    <button
                      style={Fontstyling.cancelbutton}
                      type="reset"
                      onClick={() => setShowModal(false)}
                    >
                      Cancel
                    </button>
                  </div>
                  <span className="text-success" style={{fontSize:"12px"}}>
                    * No special characters are allowed
                  </span>
                </Form>
              )}
            </Formik>
          )}
        </Modal.Body>
      </Modal>
      <div className="text-end py-3 border-bottom">
        <CustomButton
          onClick={() => {
            setWitchAction("add");
            setShowModal(true);
          }}
        >
          Add New Salary Risk
        </CustomButton>
      </div>
      <CustomMaterialTable
        isExport={true}
        column={column}
        data={data}
        selectedRow={selectedRow}
        setSelectedRow={setSelectedRow}
        setWitchAction={setWitchAction}
        setSelectedRowData={setSelectedRowData}
        setShowModal={setShowModal}
        isLoading={isLoading}
      />
    </div>
  );
};

export default SalaryRisk;
